<template>
  <div
    :class="['comp-content', component.active ? 'active' : '']"
    :style="getStyle"
    :comp-id="component.domId"
  >
    <div class="text-box" v-html="getText"></div>
  </div>
</template>

<script>
export default {
  name: "comp-text",
  props: {
    component: {
      type: Object,
    },
  },
  computed: {
    getStyle() {
      const ret = [];
      this.component.style.forEach((item) => {
        const unit = item.unit || "";
        if (item.val) {
          if (Array.isArray(item.attr)) {
            item.attr.forEach((atr, i) => {
              ret.push(atr + ":" + item.val[i]);
            });
          } else if (item.attr === "background-image") {
            ret.push(item.attr + ":url(" + item.val + ")");
          } else {
            ret.push(item.attr + ":" + item.val + unit);
          }
        }
      });
      return ret.join(";");
    },
    getText() {
      const arr = this.component.base[0].val.split("\n");
      if (arr.length) {
        return arr.join("<br/>");
      }
      return this.component.base[0].val;
    },
  }
};
</script>

<style lang="less" scoped>
.comp-content {
  background-repeat: no-repeat;
}
.text-box {
  display: block;
}
</style>
